import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '290px'),
      height: 'auto',
      borderRadius: '20px',
      opacity: 1,
      boxShadow: 'none',
      background: 'linear-gradient(180deg, #2D6DF6 0%, #0133A0 100%)',
      alignSelf: 'center',
    },
    divCard: {
      padding: ({ isMobile }: StyleProps) => (isMobile ? '30px 0' : '0 0 0 20px'),
    },
    total: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '30px',
      color: '#FFFFFF',
      textAlign: 'center',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    divider: {
      background: '#ffffff',
      '&.MuiDivider-inset': {
        margin: '0 20px',
      },
    },
    labelTotal: {
      fontFamily: 'SuraSans-Ligera',
      fontSize: '12px',
      textAlign: 'center',
      margin: ({ isMobile }: StyleProps) => (isMobile ? '0' : '5px 0'),
      color: '#ffffff',
    },
    divPoliza: {
      margin: ({ isMobile }: StyleProps) => (isMobile ? '30px 20px' : '30px 20px'),
      border: '1px solid #81B1FF',
      borderRadius: '10px',
      padding: 12,
    },
    labelPoliza: {
      color: '#ffffff',
      fontFamily: 'SuraSans-Negrita',
      fontSize: '14px',
    },
    divIcon: {
      display: 'flex',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'space-between' : 'space-between'),
    },
    iconButton: {
      padding: 0,
      height: 24,
    },
    icon: {
      color: '#ffffff',
    },
    divReceipt: {
      display: 'flex',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'space-between' : 'space-between'),
      margin: ({ isMobile }: StyleProps) => (isMobile ? '15px 0px' : '15px 0'),
    },
    labelReceipt: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '12px',
      color: '#ffffff',
    },
    labelTotalReceipt: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '14px',
      color: '#FFFFFF',
    },
    divImg: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '80px',
    },
    labelSeguros: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '20px',
      color: '#F8F8F8',
      textAlign: 'center',
      marginTop: '8px',
    },
    labelSura: {
      fontFamily: 'SuraSans-Negrita',
    },
    labelHashtag: {
      fontFamily: 'SuraSans-Fina',
      fontSize: '20px',
      color: '#F8F8F8',
      textAlign: 'center',
      marginBottom: '30px',
    },
    buttonDetail: {
      width: '80px',
      opacity: '40%',
      border: '4px solid #FFFFFF',
      borderRadius: 20,
      marginTop: '15px',
      height: '1px',
    },
    iconDetail: {
      display: 'contents',
    },
    divContracts: {
      height: ({ isMobile }: StyleProps) => (isMobile ? '80%' : '100%'),
      display: 'grid',
      alignContent: 'space-between',
    },
  }),
);

export default useStyles;
